@for (item of content().items; track $index) {
  <div
    class="heather-50-bg surface-secondary text-tip-container flex radius-xsmall"
    [class.ms-xlarge-y]="!isNewBrand()"
    [class.pr-large-y]="!isNewBrand()"
    [class.pr-medium-x]="!isNewBrand()"
    [class.pr-medium]="isNewBrand()"
  >
    <div
      class="text-tip-top"
      [class.ms-medium-b]="isNewBrand()"
      [class.mr-xlarge-x]="!isNewBrand()"
      [class.align-center]="!isNewBrand()"
    >
      @if ($index === 0 && content().teaserTitle) {
        <span class="text-tip-slogan mr-xxsmall-b block font-body-medium"
          ><strong>{{ content().teaserTitle }}</strong></span
        >
      }
      <span
        class="text-tip-heading font-title-small nordic-blue-900-text text-icon-primary block"
        [class.bold-type]="!isNewBrand()"
        >{{ item.teaserTitle }}</span
      >
    </div>
    <div [innerHtml]="item.teaserText" class="text-tip-content"></div>
  </div>
}
